import { SortEnum, UserWorkspaceStatusEnum, useWorkspaceMembersV2Query } from '@/types/generated/graphql';
import { SelectMemberTypeEnum } from '@modules/teams/teams.types';

export function useWorkspaceMembers() {
  const { data, loading } = useWorkspaceMembersV2Query({
    variables: {
      limit: 4,
      order: SelectMemberTypeEnum.lastSeenAt,
      status: UserWorkspaceStatusEnum.accepted,
      sort: SortEnum.DESC,
    },
  });
  const hasNextPage = data?.workspaceMembersV2?.cursor?.hasNextPage || false;
  return {
    data: data?.workspaceMembersV2,
    hasNextPage,
    initialLoading: loading,
  };
}
